import Typography from '@mui/material/Typography'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { IssueEntity } from 'types/IssueEntity'
import { WarrantName } from '../../../components/entities/WarrantName'
import { FactsTableRow } from '../../components/FactsTable'
import * as sharesOrUnits from '../../../utils/issues/sharesOrUnits.js'

export function UnitContentRow({ issue }: { issue: Partial<IssueEntity> }) {
    const { i18n } = useTranslation()
    const locale = i18n.language

    if (sharesOrUnits.isUnit(issue)) {
        const instrumentElements: ReactNode[] = []
        if (issue.warrants && issue.warrants.length > 0) {
            issue.warrants.forEach((warrant) => {
                const hasWarrantsPerUnitValue = warrant.warrantsPerUnit !== null && warrant.warrantsPerUnit !== 0

                instrumentElements.push(
                    <Typography key={warrant.id}>
                        {hasWarrantsPerUnitValue &&
                            sharesOrUnits.warrantsQuantityLabel(warrant.warrantsPerUnit, locale)}
                        {!hasWarrantsPerUnitValue && 'X teckningsoptioner'}:{' '}
                        <Link to={`/warrants/${warrant.id}`}>
                            <WarrantName warrant={warrant} />
                        </Link>
                        <br />
                    </Typography>,
                )
            })
        }
        if (issue.unitExtraContent) {
            instrumentElements.push(
                <Typography key='unitExtraContent'>
                    {issue.unitExtraContent}
                    <br />
                </Typography>,
            )
        }
        return (
            <FactsTableRow label='Unit'>
                {issue.sharesInUnit !== null && sharesOrUnits.sharesQuantityLabel(issue.sharesInUnit, locale)}
                {issue.sharesInUnit === null && 'X aktier'}
                <br />
                {instrumentElements}
            </FactsTableRow>
        )
    } else return null
}
